import { Button } from "@/components/ui/button";
import { MentionHoverCard } from "@/components/ui/mention-hover-card";
import { UsernamePatternRegex, getProfileLink } from "@/lib/utils";
import Link from "next/link";

export function renderMentions(text: string) {
	if (!text) return null;

	const parts = [];
	let lastIndex = 0;

	// Initialize match outside the loop
	let match = UsernamePatternRegex.exec(text);
	while (match !== null) {
		// Add text before the mention
		if (match.index > lastIndex) {
			parts.push(text.substring(lastIndex, match.index));
		}

		// Add the mention
		const username = match[1];
		parts.push(
			<MentionHoverCard key={match.index} username={username}>
				<Button variant="link" className="p-0 font-semibold">
					<Link href={getProfileLink(username)}>@{username}</Link>
				</Button>
			</MentionHoverCard>,
		);

		lastIndex = match.index + match[0].length;
		match = UsernamePatternRegex.exec(text);
	}

	// Add remaining text
	if (lastIndex < text.length) {
		parts.push(text.substring(lastIndex));
	}

	return parts;
}
